import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { CustomerSector } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class CustomerSectorService {

    static Sectors: Array<CustomerSector> = [];

    constructor(
        private apiService: ApiService
    ) {}

    async init(){   
        CustomerSectorService.Sectors = await this.loadCustomersSectors(); 
    }
    
    reset(){        
        CustomerSectorService.Sectors = [];
    }
    
    async loadCustomersSectors(): Promise<CustomerSector[]> {
        let sectors: Array<CustomerSector> = [];
        let response = await this.apiService.get('field-team/my-sectors');
        if(response?.data?.elements){
            sectors = response.data.elements;
        }
        return sectors;
    }
}
